import script from "./goRinSyo0013.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0013.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0013.vue?vue&type=style&index=0&id=0fe0845a&lang=scss"

const __exports__ = script;

export default __exports__